import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TrafficFinesService } from '../../../services/traffic-fines.service';

@Component({
  selector: 'app-traffic-fine-email-panel',
  templateUrl: './traffic-fine-email-panel.component.html',
  styleUrls: ['./traffic-fine-email-panel.component.css']
})
export class TrafficFineEmailPanelComponent {
  @Input() fineId: number | null = null;
  @Input() placa = '';
  @Input() ait = '';
  @Input() contrato = '';
  @Input() pessoa = '';
  @Input() vencimento = '';
  @Input() prazoIndicacao = '';
  @Input() dataIndicacao = '';
  @Input() descricao = '';
  @Output() enviado = new EventEmitter<void>();

  email = '';
  sending = false;
  error: string | null = null;
  success: string | null = null;

  constructor(private fines: TrafficFinesService) {}

  get emailValido(): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email.trim());
  }

  enviar(): void {
    if (!this.fineId || !this.emailValido || this.sending) {
      this.error = 'Informe um e-mail válido.';
      return;
    }

    this.sending = true;
    this.error = null;
    this.success = null;
    this.fines.enviarResumoEmail(this.fineId, this.email.trim()).subscribe({
      next: () => {
        this.sending = false;
        this.success = `Resumo enviado para ${this.email.trim()}.`;
        this.enviado.emit();
      },
      error: err => {
        this.sending = false;
        this.error = err?.error?.message || 'Não foi possível enviar o resumo da multa.';
      }
    });
  }
}
